import styled from '@emotion/styled/macro'
import { theme } from '../../../modules/App/Providers/Theme/theme'
import { FormLabel, Typography } from '@mui/material'

const DateLabel = styled('label')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  font-size: 12px;
  height: 15px;
  color: rgba(0, 0, 0, 0.54);
  user-select: text;
`

const DateContainer = styled('div')`
  display: block;
  position: relative;
  height: 50px;
  &:focus-within ${DateLabel} {
    color: ${theme.palette.primary.main};
  }
`

const AppointmentTypeContainer = styled('div')`
  display: block;
  position: relative;
  height: 50px;
  margin-bottom: 20px;
  &:focus-within ${DateLabel} {
    color: ${theme.palette.primary.main};
  }
`
const DateInputContainer = styled('div')`
  position: absolute;
  width: 100%;
  left: 0;
`

const CheckboxLabel = styled(Typography)`
  font-size: 12px;
  font-weight: normal;
`

const DeliveryModelFormLabel = styled(FormLabel)`
  font-size: 12px;
  font-weight: normal;
`

export { AppointmentTypeContainer, DateContainer, DateInputContainer, DateLabel, DeliveryModelFormLabel, CheckboxLabel }
